module.exports = __webpack_public_path__ + "media/images/flags/gb-ba1c7f5df0dd4173c951a644c65e02df.svg";